import { injectApp } from "@/lib";

import App from "./get-started.vue";

injectApp(App, true);
